import React, { Component } from 'react';
import {Header} from './header.js';
import {Footer} from './footer.js';

import './videos.css';

var faqVideos = [];

export class Videos extends Component {

     constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    return (
        <div className="Landing" id="contentId">
            <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
            <div className="ContentWithBackground">
                <div className="content" id="content">
                        <div className="productHeader1">
                            Eine kurze Erklärung des Marktplatzes als Video:
                        </div>
                    <div className="VideoBody" >
                        <iframe title='Kurze Erklärung des Marktplatzes' width='560' height='315' src="https://www.youtube.com/embed/u8-vxGjRQgc" frameborder="0" allowfullscreen></iframe>
                    </div>

                </div>
            </div>
            <Footer faqs={faqVideos}/>
      </div>

     );


}

};



// WEBPACK FOOTER //
// ./src/videos.js